import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { calculateTimeLeft, stringFormat } from '../../../../common/Helpers';


export default function NotFound(props) {
    const { t } = useTranslation();
    const history = useHistory();
    const [timeLeft, setTimeLeft] = useState(4);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                clearInterval(interval);
                history.push("/");
                return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [history]);

    return (     
            <Card className="rounded-3">
                <Card.Body>
                  <Row className="mb-3">
                    <Col sm={4} md={4} lg={4} xl={4}>
                        <h4> { t('data-lang-pagename-notfound') } </h4>
                        <p>{ stringFormat(t('data-lang-msg-notfoundredirect'), [timeLeft]) }</p>
                        <Link to="/">{ t('data-lang-lbl-gohome') }</Link>
                    </Col>
                  </Row>
                </Card.Body>
            </Card>);
};